// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AIFeatureStyle-formValueChip-Vg8e_ {
    padding: 6px 12px;
    border: 1px solid var(--primary-border);
    border-radius: 100px;
    background-color: var(--ai-badge-bg);
    font-size: 14px;
    line-height: 20px;
}

.AIFeatureStyle-copyIcon-RTnQc {
    width: 13px;
    height: 13px;
    color: var(--primary-foreground);
    cursor: pointer;
}

.AIFeatureStyle-aiGenerateTextBox-P0K5h {
    padding: 18px;
    position: relative;
    min-height: 132px;
    background: var(--primary-white-bg);
    border-radius: 4px;
}

.AIFeatureStyle-aiGenerateInputWrapper-H8UVU {
    background: var(--ai-badge-bg);
    border-radius: 16px;
    padding: 18px;
    isolation: isolate;
}

.AIFeatureStyle-aiGenerateBoxLine-g77q6 {
    background: var(--ai-border);
    -webkit-box-shadow: 0px 5px 11px 0px var(--ai-generate-input-shadow);
            box-shadow: 0px 5px 11px 0px var(--ai-generate-input-shadow);
    border-radius: 6px;
    padding: 2px;
}

.AIFeatureStyle-aiGenerateText-FFF7O {
    overflow-y: auto;
    max-height: 100px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
}

.AIFeatureStyle-copyIndicateTip-u85_Y {
    background: var(--common-tooltip-bg);
    color: var(--common-tooltip-foreground);
    border-radius: 8px;
    padding: 8px;
    font-size: 14px;
    line-height: normal;
    font-weight: 400;
    position: absolute;
    bottom: calc(100% + 5px);
    min-width: 70px;
    -webkit-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
            transform: translateX(-50%);
    left: 0;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/AIFeatures/AIFeatureStyle.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,uCAAuC;IACvC,oBAAoB;IACpB,oCAAoC;IACpC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,oEAA4D;YAA5D,4DAA4D;IAC5D,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;IAC3B,OAAO;IACP,kBAAkB;AACtB","sourcesContent":[".formValueChip {\n    padding: 6px 12px;\n    border: 1px solid var(--primary-border);\n    border-radius: 100px;\n    background-color: var(--ai-badge-bg);\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.copyIcon {\n    width: 13px;\n    height: 13px;\n    color: var(--primary-foreground);\n    cursor: pointer;\n}\n\n.aiGenerateTextBox {\n    padding: 18px;\n    position: relative;\n    min-height: 132px;\n    background: var(--primary-white-bg);\n    border-radius: 4px;\n}\n\n.aiGenerateInputWrapper {\n    background: var(--ai-badge-bg);\n    border-radius: 16px;\n    padding: 18px;\n    isolation: isolate;\n}\n\n.aiGenerateBoxLine {\n    background: var(--ai-border);\n    box-shadow: 0px 5px 11px 0px var(--ai-generate-input-shadow);\n    border-radius: 6px;\n    padding: 2px;\n}\n\n.aiGenerateText {\n    overflow-y: auto;\n    max-height: 100px;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 400;\n}\n\n.copyIndicateTip {\n    background: var(--common-tooltip-bg);\n    color: var(--common-tooltip-foreground);\n    border-radius: 8px;\n    padding: 8px;\n    font-size: 14px;\n    line-height: normal;\n    font-weight: 400;\n    position: absolute;\n    bottom: calc(100% + 5px);\n    min-width: 70px;\n    transform: translateX(-50%);\n    left: 0;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formValueChip": `AIFeatureStyle-formValueChip-Vg8e_`,
	"copyIcon": `AIFeatureStyle-copyIcon-RTnQc`,
	"aiGenerateTextBox": `AIFeatureStyle-aiGenerateTextBox-P0K5h`,
	"aiGenerateInputWrapper": `AIFeatureStyle-aiGenerateInputWrapper-H8UVU`,
	"aiGenerateBoxLine": `AIFeatureStyle-aiGenerateBoxLine-g77q6`,
	"aiGenerateText": `AIFeatureStyle-aiGenerateText-FFF7O`,
	"copyIndicateTip": `AIFeatureStyle-copyIndicateTip-u85_Y`
};
module.exports = ___CSS_LOADER_EXPORT___;
